import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { Container as ContainerBase } from './Container';
export var Container = styled(ContainerBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  overflow: auto;\n  padding: 0;\n"], ["\n  height: 100%;\n  overflow: auto;\n  padding: 0;\n"])));
export var ContainerInner = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: auto;\n  padding-bottom: 1rem;\n"], ["\n  height: auto;\n  padding-bottom: 1rem;\n"])));
var templateObject_1, templateObject_2;
